import { render, staticRenderFns } from "./IconCakeOutline.vue?vue&type=template&id=e49b8d4a"
import script from "./IconCakeOutline.vue?vue&type=script&lang=js"
export * from "./IconCakeOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports